import {environment} from '../../../environments/environment';
import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MyHttpClient} from '../../shared/services/my-http-client.service';

@Injectable()
export class HttpServiceBase {
    protected readonly securityServerAddress: string = environment.securityServerAddress;

    protected readonly serverAddress: string = environment.serverAddress;

    protected httpClient: MyHttpClient = inject(MyHttpClient);

    constructor() {

        if (this.serverAddress.includes('api')) {
            const apiIndex = this.serverAddress.indexOf('api') + 3; // Find the end of "api"
            this.serverAddress = this.serverAddress.slice(0, apiIndex);
        }

        if (this.securityServerAddress.includes('api')) {
            const apiIndex = this.securityServerAddress.indexOf('api') + 3; // Find the end of "api"
            this.securityServerAddress = this.securityServerAddress.slice(0, apiIndex);
        }
    }

}
